var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"meeting_agree_sign"},[_c('base-sign',{ref:"refBaseSign",on:{"uploadSucc":_vm.signUploadSuccess}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }